import RTableLayout from "../../../layout/RTableLayout";
import { CMargin, DText, Flex, Row } from "../../../../../styles/CommonStyles";
import { formatDate } from "../../../../../core/utils/common";
import Text from "../../../../../core/utils/Text";
import { useMainContext } from "../../../../../core/contexts/main";
import { RespIndex } from "../../../../../styles/main/MainCommonStyles";

const RRewardListTable = ({
    data
}) => {
    const { lang } = useMainContext();
    const { data: rewards } = data;

    return (
        <RTableLayout data={!!rewards}>
            {rewards?.map((item, idx) => {
                const affiliatedUserFullName = `${item.affiliatedUser?.firstName || '-'} ${item.affiliatedUser?.lastName || '-'}`;
                const userFullName = `${item.user?.firstName || '-'} ${item.user?.lastName || '-'}`;
                const amount = item.data?.amount ?? '-';
                const currency = item.data?.currency?.toUpperCase() ?? '-';
                const type = item.type || '-';

                return (
                    <Row cs={'100%'} index={idx} key={item._id}>
                        <CMargin margin={'8px'} />

                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                Affiliated User :
                            </DText>
                            <DText fontSize="s">{affiliatedUserFullName}</DText>
                        </Flex>

                        <CMargin margin={'8px'} />
                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                User :
                            </DText>
                            <DText fontSize="s">{userFullName}</DText>
                        </Flex>

                        <CMargin margin={'8px'} />
                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                Currency :
                            </DText>
                            <DText fontSize="s">{currency}</DText>
                        </Flex>

                        <CMargin margin={'8px'} />
                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                Amount :
                            </DText>
                            <DText fontSize="s">{amount}</DText>
                        </Flex>

                        <CMargin margin={'8px'} />
                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                Type :
                            </DText>
                            <DText fontSize="s">{type}</DText>
                        </Flex>

                        <CMargin margin={'8px'} />
                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                <Text tid="date" /> :
                            </DText>
                            <DText fontSize="s">{formatDate(item.createdAt, 'date', lang)}</DText>
                        </Flex>

                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                <Text tid="time" /> :
                            </DText>
                            <DText fontSize="s">{formatDate(item.createdAt, 'time', lang)}</DText>
                        </Flex>

                        <RespIndex>{idx + 1}</RespIndex>
                    </Row>
                );
            })}
        </RTableLayout>
    );
};

export default RRewardListTable;
